// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/artifacts/v1/diff.proto (package chalk.artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CDCSource } from "./cdc_pb";
import { file_chalk_artifacts_v1_cdc } from "./cdc_pb";
import type { Chart } from "./chart_pb";
import { file_chalk_artifacts_v1_chart } from "./chart_pb";
import type { CronAggregateBackfill } from "./cron_aggregate_backfill_pb";
import { file_chalk_artifacts_v1_cron_aggregate_backfill } from "./cron_aggregate_backfill_pb";
import type { CronQuery } from "./cron_query_pb";
import { file_chalk_artifacts_v1_cron_query } from "./cron_query_pb";
import type { FeatureSet, FeatureType, ModelReference, NamedQuery, OnlineStoreConfig, Resolver, SinkResolver, StreamResolver } from "../../graph/v1/graph_pb";
import { file_chalk_graph_v1_graph } from "../../graph/v1/graph_pb";
import type { DatabaseSource, DatabaseSourceGroup, StreamSource } from "../../graph/v2/sources_pb";
import { file_chalk_graph_v2_sources } from "../../graph/v2/sources_pb";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/artifacts/v1/diff.proto.
 */
export const file_chalk_artifacts_v1_diff: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_artifacts_v1_cdc, file_chalk_artifacts_v1_chart, file_chalk_artifacts_v1_cron_aggregate_backfill, file_chalk_artifacts_v1_cron_query, file_chalk_graph_v1_graph, file_chalk_graph_v2_sources, file_google_protobuf_field_mask]);

/**
 * @generated from message chalk.artifacts.v1.ExportDiff
 */
export type ExportDiff = Message<"chalk.artifacts.v1.ExportDiff"> & {
  /**
   * @generated from field: chalk.artifacts.v1.FeatureSetCollectionDiff feature_sets = 1;
   */
  featureSets?: FeatureSetCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.ResolverCollectionDiff resolvers = 2;
   */
  resolvers?: ResolverCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.StreamResolverCollectionDiff stream_resolvers = 3;
   */
  streamResolvers?: StreamResolverCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.SinkResolverCollectionDiff sink_resolvers = 4;
   */
  sinkResolvers?: SinkResolverCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.NamedQueryCollectionDiff named_queries = 5;
   */
  namedQueries?: NamedQueryCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.DatabaseSourceCollectionDiff database_sources_v2 = 6;
   */
  databaseSourcesV2?: DatabaseSourceCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.StreamSourceCollectionDiff stream_sources_v2 = 7;
   */
  streamSourcesV2?: StreamSourceCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.ModelReferenceCollectionDiff model_references = 8;
   */
  modelReferences?: ModelReferenceCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.OnlineStoreConfigCollectionDiff online_store_configs = 9;
   */
  onlineStoreConfigs?: OnlineStoreConfigCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.DatabaseSourceGroupCollectionDiff database_source_groups = 10;
   */
  databaseSourceGroups?: DatabaseSourceGroupCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.CronQueryCollectionDiff crons = 11;
   */
  crons?: CronQueryCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.ChartCollectionDiff charts = 12;
   */
  charts?: ChartCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.CDCSourceCollectionDiff cdc_sources = 13;
   */
  cdcSources?: CDCSourceCollectionDiff;

  /**
   * @generated from field: chalk.artifacts.v1.CronAggregateBackfillCollectionDiff cron_aggregate_backfills = 14;
   */
  cronAggregateBackfills?: CronAggregateBackfillCollectionDiff;
};

/**
 * Describes the message chalk.artifacts.v1.ExportDiff.
 * Use `create(ExportDiffSchema)` to create a new message.
 */
export const ExportDiffSchema: GenMessage<ExportDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 0);

/**
 * @generated from message chalk.artifacts.v1.FeatureSetCollectionDiff
 */
export type FeatureSetCollectionDiff = Message<"chalk.artifacts.v1.FeatureSetCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v1.FeatureSet added = 1;
   */
  added: FeatureSet[];

  /**
   * @generated from field: repeated chalk.graph.v1.FeatureSet removed = 2;
   */
  removed: FeatureSet[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.FeatureSetModified modified = 3;
   */
  modified: FeatureSetModified[];
};

/**
 * Describes the message chalk.artifacts.v1.FeatureSetCollectionDiff.
 * Use `create(FeatureSetCollectionDiffSchema)` to create a new message.
 */
export const FeatureSetCollectionDiffSchema: GenMessage<FeatureSetCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 1);

/**
 * @generated from message chalk.artifacts.v1.FeatureSetModified
 */
export type FeatureSetModified = Message<"chalk.artifacts.v1.FeatureSetModified"> & {
  /**
   * @generated from field: chalk.graph.v1.FeatureSet before = 1;
   */
  before?: FeatureSet;

  /**
   * @generated from field: chalk.graph.v1.FeatureSet after = 2;
   */
  after?: FeatureSet;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;

  /**
   * @generated from field: chalk.artifacts.v1.FeatureTypeCollectionDiff features = 4;
   */
  features?: FeatureTypeCollectionDiff;
};

/**
 * Describes the message chalk.artifacts.v1.FeatureSetModified.
 * Use `create(FeatureSetModifiedSchema)` to create a new message.
 */
export const FeatureSetModifiedSchema: GenMessage<FeatureSetModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 2);

/**
 * @generated from message chalk.artifacts.v1.FeatureTypeCollectionDiff
 */
export type FeatureTypeCollectionDiff = Message<"chalk.artifacts.v1.FeatureTypeCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v1.FeatureType added = 1;
   */
  added: FeatureType[];

  /**
   * @generated from field: repeated chalk.graph.v1.FeatureType removed = 2;
   */
  removed: FeatureType[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.FeatureTypeModified modified = 3;
   */
  modified: FeatureTypeModified[];
};

/**
 * Describes the message chalk.artifacts.v1.FeatureTypeCollectionDiff.
 * Use `create(FeatureTypeCollectionDiffSchema)` to create a new message.
 */
export const FeatureTypeCollectionDiffSchema: GenMessage<FeatureTypeCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 3);

/**
 * @generated from message chalk.artifacts.v1.FeatureTypeModified
 */
export type FeatureTypeModified = Message<"chalk.artifacts.v1.FeatureTypeModified"> & {
  /**
   * @generated from field: chalk.graph.v1.FeatureType before = 1;
   */
  before?: FeatureType;

  /**
   * @generated from field: chalk.graph.v1.FeatureType after = 2;
   */
  after?: FeatureType;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.FeatureTypeModified.
 * Use `create(FeatureTypeModifiedSchema)` to create a new message.
 */
export const FeatureTypeModifiedSchema: GenMessage<FeatureTypeModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 4);

/**
 * @generated from message chalk.artifacts.v1.ResolverCollectionDiff
 */
export type ResolverCollectionDiff = Message<"chalk.artifacts.v1.ResolverCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v1.Resolver added = 1;
   */
  added: Resolver[];

  /**
   * @generated from field: repeated chalk.graph.v1.Resolver removed = 2;
   */
  removed: Resolver[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.ResolverModified modified = 3;
   */
  modified: ResolverModified[];
};

/**
 * Describes the message chalk.artifacts.v1.ResolverCollectionDiff.
 * Use `create(ResolverCollectionDiffSchema)` to create a new message.
 */
export const ResolverCollectionDiffSchema: GenMessage<ResolverCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 5);

/**
 * @generated from message chalk.artifacts.v1.ResolverModified
 */
export type ResolverModified = Message<"chalk.artifacts.v1.ResolverModified"> & {
  /**
   * @generated from field: chalk.graph.v1.Resolver before = 1;
   */
  before?: Resolver;

  /**
   * @generated from field: chalk.graph.v1.Resolver after = 2;
   */
  after?: Resolver;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.ResolverModified.
 * Use `create(ResolverModifiedSchema)` to create a new message.
 */
export const ResolverModifiedSchema: GenMessage<ResolverModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 6);

/**
 * @generated from message chalk.artifacts.v1.StreamResolverCollectionDiff
 */
export type StreamResolverCollectionDiff = Message<"chalk.artifacts.v1.StreamResolverCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v1.StreamResolver added = 1;
   */
  added: StreamResolver[];

  /**
   * @generated from field: repeated chalk.graph.v1.StreamResolver removed = 2;
   */
  removed: StreamResolver[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.StreamResolverModified modified = 3;
   */
  modified: StreamResolverModified[];
};

/**
 * Describes the message chalk.artifacts.v1.StreamResolverCollectionDiff.
 * Use `create(StreamResolverCollectionDiffSchema)` to create a new message.
 */
export const StreamResolverCollectionDiffSchema: GenMessage<StreamResolverCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 7);

/**
 * @generated from message chalk.artifacts.v1.StreamResolverModified
 */
export type StreamResolverModified = Message<"chalk.artifacts.v1.StreamResolverModified"> & {
  /**
   * @generated from field: chalk.graph.v1.StreamResolver before = 1;
   */
  before?: StreamResolver;

  /**
   * @generated from field: chalk.graph.v1.StreamResolver after = 2;
   */
  after?: StreamResolver;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.StreamResolverModified.
 * Use `create(StreamResolverModifiedSchema)` to create a new message.
 */
export const StreamResolverModifiedSchema: GenMessage<StreamResolverModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 8);

/**
 * @generated from message chalk.artifacts.v1.SinkResolverCollectionDiff
 */
export type SinkResolverCollectionDiff = Message<"chalk.artifacts.v1.SinkResolverCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v1.SinkResolver added = 1;
   */
  added: SinkResolver[];

  /**
   * @generated from field: repeated chalk.graph.v1.SinkResolver removed = 2;
   */
  removed: SinkResolver[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.SinkResolverModified modified = 3;
   */
  modified: SinkResolverModified[];
};

/**
 * Describes the message chalk.artifacts.v1.SinkResolverCollectionDiff.
 * Use `create(SinkResolverCollectionDiffSchema)` to create a new message.
 */
export const SinkResolverCollectionDiffSchema: GenMessage<SinkResolverCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 9);

/**
 * @generated from message chalk.artifacts.v1.SinkResolverModified
 */
export type SinkResolverModified = Message<"chalk.artifacts.v1.SinkResolverModified"> & {
  /**
   * @generated from field: chalk.graph.v1.SinkResolver before = 1;
   */
  before?: SinkResolver;

  /**
   * @generated from field: chalk.graph.v1.SinkResolver after = 2;
   */
  after?: SinkResolver;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.SinkResolverModified.
 * Use `create(SinkResolverModifiedSchema)` to create a new message.
 */
export const SinkResolverModifiedSchema: GenMessage<SinkResolverModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 10);

/**
 * @generated from message chalk.artifacts.v1.NamedQueryCollectionDiff
 */
export type NamedQueryCollectionDiff = Message<"chalk.artifacts.v1.NamedQueryCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v1.NamedQuery added = 1;
   */
  added: NamedQuery[];

  /**
   * @generated from field: repeated chalk.graph.v1.NamedQuery removed = 2;
   */
  removed: NamedQuery[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.NamedQueryModified modified = 3;
   */
  modified: NamedQueryModified[];
};

/**
 * Describes the message chalk.artifacts.v1.NamedQueryCollectionDiff.
 * Use `create(NamedQueryCollectionDiffSchema)` to create a new message.
 */
export const NamedQueryCollectionDiffSchema: GenMessage<NamedQueryCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 11);

/**
 * @generated from message chalk.artifacts.v1.NamedQueryModified
 */
export type NamedQueryModified = Message<"chalk.artifacts.v1.NamedQueryModified"> & {
  /**
   * @generated from field: chalk.graph.v1.NamedQuery before = 1;
   */
  before?: NamedQuery;

  /**
   * @generated from field: chalk.graph.v1.NamedQuery after = 2;
   */
  after?: NamedQuery;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.NamedQueryModified.
 * Use `create(NamedQueryModifiedSchema)` to create a new message.
 */
export const NamedQueryModifiedSchema: GenMessage<NamedQueryModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 12);

/**
 * @generated from message chalk.artifacts.v1.DatabaseSourceCollectionDiff
 */
export type DatabaseSourceCollectionDiff = Message<"chalk.artifacts.v1.DatabaseSourceCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v2.DatabaseSource added = 1;
   */
  added: DatabaseSource[];

  /**
   * @generated from field: repeated chalk.graph.v2.DatabaseSource removed = 2;
   */
  removed: DatabaseSource[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.DatabaseSourceModified modified = 3;
   */
  modified: DatabaseSourceModified[];
};

/**
 * Describes the message chalk.artifacts.v1.DatabaseSourceCollectionDiff.
 * Use `create(DatabaseSourceCollectionDiffSchema)` to create a new message.
 */
export const DatabaseSourceCollectionDiffSchema: GenMessage<DatabaseSourceCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 13);

/**
 * @generated from message chalk.artifacts.v1.DatabaseSourceModified
 */
export type DatabaseSourceModified = Message<"chalk.artifacts.v1.DatabaseSourceModified"> & {
  /**
   * @generated from field: chalk.graph.v2.DatabaseSource before = 1;
   */
  before?: DatabaseSource;

  /**
   * @generated from field: chalk.graph.v2.DatabaseSource after = 2;
   */
  after?: DatabaseSource;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.DatabaseSourceModified.
 * Use `create(DatabaseSourceModifiedSchema)` to create a new message.
 */
export const DatabaseSourceModifiedSchema: GenMessage<DatabaseSourceModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 14);

/**
 * @generated from message chalk.artifacts.v1.StreamSourceCollectionDiff
 */
export type StreamSourceCollectionDiff = Message<"chalk.artifacts.v1.StreamSourceCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v2.StreamSource added = 1;
   */
  added: StreamSource[];

  /**
   * @generated from field: repeated chalk.graph.v2.StreamSource removed = 2;
   */
  removed: StreamSource[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.StreamSourceModified modified = 3;
   */
  modified: StreamSourceModified[];
};

/**
 * Describes the message chalk.artifacts.v1.StreamSourceCollectionDiff.
 * Use `create(StreamSourceCollectionDiffSchema)` to create a new message.
 */
export const StreamSourceCollectionDiffSchema: GenMessage<StreamSourceCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 15);

/**
 * @generated from message chalk.artifacts.v1.StreamSourceModified
 */
export type StreamSourceModified = Message<"chalk.artifacts.v1.StreamSourceModified"> & {
  /**
   * @generated from field: chalk.graph.v2.StreamSource before = 1;
   */
  before?: StreamSource;

  /**
   * @generated from field: chalk.graph.v2.StreamSource after = 2;
   */
  after?: StreamSource;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.StreamSourceModified.
 * Use `create(StreamSourceModifiedSchema)` to create a new message.
 */
export const StreamSourceModifiedSchema: GenMessage<StreamSourceModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 16);

/**
 * @generated from message chalk.artifacts.v1.ModelReferenceCollectionDiff
 */
export type ModelReferenceCollectionDiff = Message<"chalk.artifacts.v1.ModelReferenceCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v1.ModelReference added = 1;
   */
  added: ModelReference[];

  /**
   * @generated from field: repeated chalk.graph.v1.ModelReference removed = 2;
   */
  removed: ModelReference[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.ModelReferenceModified modified = 3;
   */
  modified: ModelReferenceModified[];
};

/**
 * Describes the message chalk.artifacts.v1.ModelReferenceCollectionDiff.
 * Use `create(ModelReferenceCollectionDiffSchema)` to create a new message.
 */
export const ModelReferenceCollectionDiffSchema: GenMessage<ModelReferenceCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 17);

/**
 * @generated from message chalk.artifacts.v1.ModelReferenceModified
 */
export type ModelReferenceModified = Message<"chalk.artifacts.v1.ModelReferenceModified"> & {
  /**
   * @generated from field: chalk.graph.v1.ModelReference before = 1;
   */
  before?: ModelReference;

  /**
   * @generated from field: chalk.graph.v1.ModelReference after = 2;
   */
  after?: ModelReference;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.ModelReferenceModified.
 * Use `create(ModelReferenceModifiedSchema)` to create a new message.
 */
export const ModelReferenceModifiedSchema: GenMessage<ModelReferenceModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 18);

/**
 * @generated from message chalk.artifacts.v1.DatabaseSourceGroupCollectionDiff
 */
export type DatabaseSourceGroupCollectionDiff = Message<"chalk.artifacts.v1.DatabaseSourceGroupCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v2.DatabaseSourceGroup added = 1;
   */
  added: DatabaseSourceGroup[];

  /**
   * @generated from field: repeated chalk.graph.v2.DatabaseSourceGroup removed = 2;
   */
  removed: DatabaseSourceGroup[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.DatabaseSourceGroupModified modified = 3;
   */
  modified: DatabaseSourceGroupModified[];
};

/**
 * Describes the message chalk.artifacts.v1.DatabaseSourceGroupCollectionDiff.
 * Use `create(DatabaseSourceGroupCollectionDiffSchema)` to create a new message.
 */
export const DatabaseSourceGroupCollectionDiffSchema: GenMessage<DatabaseSourceGroupCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 19);

/**
 * @generated from message chalk.artifacts.v1.DatabaseSourceGroupModified
 */
export type DatabaseSourceGroupModified = Message<"chalk.artifacts.v1.DatabaseSourceGroupModified"> & {
  /**
   * @generated from field: chalk.graph.v2.DatabaseSourceGroup before = 1;
   */
  before?: DatabaseSourceGroup;

  /**
   * @generated from field: chalk.graph.v2.DatabaseSourceGroup after = 2;
   */
  after?: DatabaseSourceGroup;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.DatabaseSourceGroupModified.
 * Use `create(DatabaseSourceGroupModifiedSchema)` to create a new message.
 */
export const DatabaseSourceGroupModifiedSchema: GenMessage<DatabaseSourceGroupModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 20);

/**
 * @generated from message chalk.artifacts.v1.OnlineStoreConfigCollectionDiff
 */
export type OnlineStoreConfigCollectionDiff = Message<"chalk.artifacts.v1.OnlineStoreConfigCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.graph.v1.OnlineStoreConfig added = 1;
   */
  added: OnlineStoreConfig[];

  /**
   * @generated from field: repeated chalk.graph.v1.OnlineStoreConfig removed = 2;
   */
  removed: OnlineStoreConfig[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.OnlineStoreConfigModified modified = 3;
   */
  modified: OnlineStoreConfigModified[];
};

/**
 * Describes the message chalk.artifacts.v1.OnlineStoreConfigCollectionDiff.
 * Use `create(OnlineStoreConfigCollectionDiffSchema)` to create a new message.
 */
export const OnlineStoreConfigCollectionDiffSchema: GenMessage<OnlineStoreConfigCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 21);

/**
 * @generated from message chalk.artifacts.v1.OnlineStoreConfigModified
 */
export type OnlineStoreConfigModified = Message<"chalk.artifacts.v1.OnlineStoreConfigModified"> & {
  /**
   * @generated from field: chalk.graph.v1.OnlineStoreConfig before = 1;
   */
  before?: OnlineStoreConfig;

  /**
   * @generated from field: chalk.graph.v1.OnlineStoreConfig after = 2;
   */
  after?: OnlineStoreConfig;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.OnlineStoreConfigModified.
 * Use `create(OnlineStoreConfigModifiedSchema)` to create a new message.
 */
export const OnlineStoreConfigModifiedSchema: GenMessage<OnlineStoreConfigModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 22);

/**
 * @generated from message chalk.artifacts.v1.CronQueryCollectionDiff
 */
export type CronQueryCollectionDiff = Message<"chalk.artifacts.v1.CronQueryCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.artifacts.v1.CronQuery added = 1;
   */
  added: CronQuery[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.CronQuery removed = 2;
   */
  removed: CronQuery[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.CronQueryModified modified = 3;
   */
  modified: CronQueryModified[];
};

/**
 * Describes the message chalk.artifacts.v1.CronQueryCollectionDiff.
 * Use `create(CronQueryCollectionDiffSchema)` to create a new message.
 */
export const CronQueryCollectionDiffSchema: GenMessage<CronQueryCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 23);

/**
 * @generated from message chalk.artifacts.v1.CronQueryModified
 */
export type CronQueryModified = Message<"chalk.artifacts.v1.CronQueryModified"> & {
  /**
   * @generated from field: chalk.artifacts.v1.CronQuery before = 1;
   */
  before?: CronQuery;

  /**
   * @generated from field: chalk.artifacts.v1.CronQuery after = 2;
   */
  after?: CronQuery;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.CronQueryModified.
 * Use `create(CronQueryModifiedSchema)` to create a new message.
 */
export const CronQueryModifiedSchema: GenMessage<CronQueryModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 24);

/**
 * @generated from message chalk.artifacts.v1.ChartCollectionDiff
 */
export type ChartCollectionDiff = Message<"chalk.artifacts.v1.ChartCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.artifacts.v1.Chart added = 1;
   */
  added: Chart[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.Chart removed = 2;
   */
  removed: Chart[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.ChartModified modified = 3;
   */
  modified: ChartModified[];
};

/**
 * Describes the message chalk.artifacts.v1.ChartCollectionDiff.
 * Use `create(ChartCollectionDiffSchema)` to create a new message.
 */
export const ChartCollectionDiffSchema: GenMessage<ChartCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 25);

/**
 * @generated from message chalk.artifacts.v1.ChartModified
 */
export type ChartModified = Message<"chalk.artifacts.v1.ChartModified"> & {
  /**
   * @generated from field: chalk.artifacts.v1.Chart before = 1;
   */
  before?: Chart;

  /**
   * @generated from field: chalk.artifacts.v1.Chart after = 2;
   */
  after?: Chart;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.ChartModified.
 * Use `create(ChartModifiedSchema)` to create a new message.
 */
export const ChartModifiedSchema: GenMessage<ChartModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 26);

/**
 * @generated from message chalk.artifacts.v1.CDCSourceCollectionDiff
 */
export type CDCSourceCollectionDiff = Message<"chalk.artifacts.v1.CDCSourceCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.artifacts.v1.CDCSource added = 1;
   */
  added: CDCSource[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.CDCSource removed = 2;
   */
  removed: CDCSource[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.CDCSourceModified modified = 3;
   */
  modified: CDCSourceModified[];
};

/**
 * Describes the message chalk.artifacts.v1.CDCSourceCollectionDiff.
 * Use `create(CDCSourceCollectionDiffSchema)` to create a new message.
 */
export const CDCSourceCollectionDiffSchema: GenMessage<CDCSourceCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 27);

/**
 * @generated from message chalk.artifacts.v1.CDCSourceModified
 */
export type CDCSourceModified = Message<"chalk.artifacts.v1.CDCSourceModified"> & {
  /**
   * @generated from field: chalk.artifacts.v1.CDCSource before = 1;
   */
  before?: CDCSource;

  /**
   * @generated from field: chalk.artifacts.v1.CDCSource after = 2;
   */
  after?: CDCSource;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.CDCSourceModified.
 * Use `create(CDCSourceModifiedSchema)` to create a new message.
 */
export const CDCSourceModifiedSchema: GenMessage<CDCSourceModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 28);

/**
 * @generated from message chalk.artifacts.v1.CronAggregateBackfillCollectionDiff
 */
export type CronAggregateBackfillCollectionDiff = Message<"chalk.artifacts.v1.CronAggregateBackfillCollectionDiff"> & {
  /**
   * @generated from field: repeated chalk.artifacts.v1.CronAggregateBackfill added = 1;
   */
  added: CronAggregateBackfill[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.CronAggregateBackfill removed = 2;
   */
  removed: CronAggregateBackfill[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.CronAggregateBackfillModified modified = 3;
   */
  modified: CronAggregateBackfillModified[];
};

/**
 * Describes the message chalk.artifacts.v1.CronAggregateBackfillCollectionDiff.
 * Use `create(CronAggregateBackfillCollectionDiffSchema)` to create a new message.
 */
export const CronAggregateBackfillCollectionDiffSchema: GenMessage<CronAggregateBackfillCollectionDiff> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 29);

/**
 * @generated from message chalk.artifacts.v1.CronAggregateBackfillModified
 */
export type CronAggregateBackfillModified = Message<"chalk.artifacts.v1.CronAggregateBackfillModified"> & {
  /**
   * @generated from field: chalk.artifacts.v1.CronAggregateBackfill before = 1;
   */
  before?: CronAggregateBackfill;

  /**
   * @generated from field: chalk.artifacts.v1.CronAggregateBackfill after = 2;
   */
  after?: CronAggregateBackfill;

  /**
   * @generated from field: google.protobuf.FieldMask changed_fields = 3;
   */
  changedFields?: FieldMask;
};

/**
 * Describes the message chalk.artifacts.v1.CronAggregateBackfillModified.
 * Use `create(CronAggregateBackfillModifiedSchema)` to create a new message.
 */
export const CronAggregateBackfillModifiedSchema: GenMessage<CronAggregateBackfillModified> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_diff, 30);

